import * as SectionTemplateListAction from './action';
const initialState = {
    sectionTemplateListData: [],
    getSectionTemplateListFail: null,
    downloadMasterTemplate: [],
    downloadMasterTemplateFailure: [],
    uploadMasterTemplate: [],
    uploadMasterTemplateFailure: []
}

const sectionTemplateListReducer = (state = initialState, action) => {
    switch (action.type) {
        case SectionTemplateListAction.GET_SECTION_TEMPLATE_SUCCESSFULL:
            return state = {
                ...state,
                sectionTemplateListData: action.data
            }
        case SectionTemplateListAction.GET_SECTION_TEMPLATE_FAILURE:
            return state = {
                ...state,
                getSectionTemplateListFail: action.data
            }
        case SectionTemplateListAction.DOWNLOAD_MASTER_DATA_KEY_TEMPLATE_SUCCESSFULL:
            return state = {
                ...state,
                downloadMasterTemplate: action.data
            }
        case SectionTemplateListAction.DOWNLOAD_MASTER_DATA_KEY_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadMasterTemplateFailure: action.data
            }
        case SectionTemplateListAction.UPLOAD_BULK_MASTER_DATA_KEY_SUCCESSFULL:
            return state = {
                ...state,
                uploadMasterTemplate: action.data
            }
        case SectionTemplateListAction.UPLOAD_BULK_MASTER_DATA_KEY_FAILURE:
            return state = {
                ...state,
                uploadMasterTemplateFailure: action.data
            }
        default: return state

    }
}
export default sectionTemplateListReducer;